import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Box,
  Typography,
  DialogTitle,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface ConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
}

export const ConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  isLoading = false,
}: ConfirmationModalProps) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <Box
          sx={{
            borderRadius: '50%',
            border: '1px solid',
            borderColor: 'divider',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'info.muted',
            width: 40,
            height: 40,
          }}
        >
          <InfoOutlinedIcon color="primary" />
        </Box>
      </DialogTitle>
      <DialogContent
        sx={{
          minWidth: 553,
        }}
      >
        {isLoading ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
              minHeight: 100,
            }}
          >
            <CircularProgress size={24} />
            {message}
          </Box>
        ) : (
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Box>
              <Typography
                variant="h4"
                sx={{
                  fontSize: '16px',
                  fontWeight: 500,
                  mb: 1,
                }}
              >
                {title}
              </Typography>
              {message}
            </Box>
          </Box>
        )}
      </DialogContent>
      {!isLoading && (
        <DialogActions>
          <Button onClick={onClose}>{cancelText}</Button>
          <Button onClick={onConfirm} variant="contained" color="primary">
            {confirmText}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};
